module.exports = __webpack_public_path__ + "static/promo-88398bb056905a156ffddff4026fc143.png";